import React from 'react';
import { powerRound } from '.';
import { UnitSystem } from '../enums';

export const getPowerUnit = (unitSystem: UnitSystem) => {
    let unit: string;

    switch (unitSystem) {
        case UnitSystem.SI:
        case UnitSystem.MKSA:
            unit = '[kW]';
            break;
        case UnitSystem.Imperial:
            unit = '[HP]';
            break;
    }

    return unit;
};

export const getTorqueUnit = (unitSystem: UnitSystem) => {
    let unit: string;

    switch (unitSystem) {
        case UnitSystem.SI:
            unit = '[Nm]';
            break;
        case UnitSystem.MKSA:
            unit = '[kgf.m]';
            break;
        case UnitSystem.Imperial:
            unit = '[lb-ft]';
            break;
    }

    return unit;
};


export const getInertiaUnit = (unitSystem: UnitSystem) => {
    let unit: string;
    const squareSign = '&sup2;';

    switch (unitSystem) {
        case UnitSystem.SI:
            unit = ` [kgm${squareSign}]`;
            break;
        case UnitSystem.MKSA:
            unit = ` [kgf.m${squareSign}(GD${squareSign})]`;
            break;
        case UnitSystem.Imperial:
            unit = ` [lb-ft${squareSign}(WK${squareSign})]`;
            break;
    }

    return unit;
};

export const convertKWToHP = (value: number) => {
    return value && powerRound(value * 1.34098);
};
